export default __webpack_public_path__ + "static/media/615.35a27afa.png";